import { createAction } from "redux-actions";
import { GET_COMPANY } from "../constants";
import { feathersFindDataAll } from "../services";

export const getCompany = createAction(GET_COMPANY, (id) => feathersFindDataAll('companies',{ id, state: true})())
